import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import RefreshIcon from '@mui/icons-material/Refresh';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import AreaTitle from '../../../components/areaTitle/AreaTitle';
import TrialOutreachHistoryTable from './components/TrialOutreachHistoryTable';
import useTrialOutreachHistory from './hooks/useTrialOutreachHistory';

/**
 * AdminTrialOutreach - Histórico do contato com contas em teste (Admin Geral)
 *
 * O envio é da rotina diária (automations/send_trial_outreach.php); a tela
 * mostra quem recebeu (também pelo "Enviar mensagem" da empresa), quando, por
 * qual canal e o texto, e é onde se marca o resultado do contato.
 * Regras: docs/features/admin-trial-outreach/README.md
 */
function AdminTrialOutreach() {
  const { items, isLoading, error, refresh, setOutcome } = useTrialOutreachHistory();

  return (
    <Box sx={{ backgroundColor: '#F8F9FC', minHeight: '100vh', p: { xs: 2, md: 3 } }}>
      <Box sx={{ mb: 3 }}>
        <AreaTitle
          Title="Admin Geral · Contato com testes"
          Icon={<ForumOutlinedIcon />}
          Description="Todo dia às 10h a rotina manda uma mensagem pessoal: quem tem o teste vencendo em até 3 dias recebe oferta de ajuda; quem já venceu (depois da oferta de desconto) recebe o convite para voltar com mais 14 dias, uma vez só. Sai pelo WhatsApp da Gabriela ou por e-mail. A lista também mostra o que foi mandado pelo Enviar mensagem da empresa; marque em cada linha o resultado do contato."
        />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Mensagens: <strong>{items.length}</strong>
        </Typography>
        <Box sx={{ flex: 1 }} />
        <Button
          variant="outlined"
          startIcon={<RefreshIcon fontSize="small" />}
          onClick={refresh}
          disabled={isLoading}
          sx={{ borderRadius: '8px', textTransform: 'none', fontWeight: 600 }}
        >
          Atualizar
        </Button>
      </Box>

      <TrialOutreachHistoryTable items={items} isLoading={isLoading} error={error} onOutcomeSaved={setOutcome} />
    </Box>
  );
}

export default AdminTrialOutreach;
